import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/dist/react';
import BannerSystem from './utils/BannerSystem';

import Navbar from './components/Navbar';
import Footer from './components/Footer';
import { Home, NotFound, Experiments, Contact, Services, PrivacyPolicy } from './pages';

const AppContent = () => {
  return (
    <>
      <Navbar />
      <BannerSystem />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/experiments" element={<Experiments />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
    </>
  );
};

const App = () => {
  return (
    <>
      <Router>
        <AppContent />
      </Router>
      <Analytics />
    </>
  );
};

export default App;
